module.exports = __webpack_public_path__ + "img/the1.29705cc5.png";